import axios from 'axios'
import store from '../store'
import { getToken } from '../utils/auth'
import { Notification } from 'element-ui'

function toShortDomain (hostname) {
  if (hostname.startsWith('www.')) {
    // 把 www. 開頭換成 short.
    return hostname.replace(/^www\./, 'short.')
  } else {
    // 沒有 www，直接前面加上 short.
    return `short.${hostname}`
  }
}

const isProd = process.env.NODE_ENV === 'production'
let baseURL = ''

if (isProd) {
  const host = window.location.hostname
  const shortHost = toShortDomain(host)
  baseURL = `${window.location.protocol}//${shortHost}`
} else {
  baseURL = process.env.VUE_APP_BASE_URL
}

const service = axios.create({
  baseURL,
  timeout: 20000
})

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    if (error.response.status == 401) {
      Notification({
        title: '提示',
        message: '登录过期,请重新登录',
        type: 'error'
      })
      store.commit('SET_TOKEN', '')
      localStorage.clear()
      setTimeout(() => {
        window.location.href = '/'
      }, 1000)
    }
    return Promise.reject(error)
  }
)

export default service
